export default "__VITE_ASSET__B5W31DJD__"